import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const FieldWrapper = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  width: ${(p) => (p.$fullWidth ? '100%' : 'auto')};
`;

export const FieldLabel = styled.label<{ $error?: boolean }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$error ? semantic.text.danger : semantic.text.primary)};
`;

export const RequiredMark = styled.span`
  color: inherit;
`;

export const TextInput = styled.input`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  padding: ${layout.inputPadding};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-md']};
  color: ${semantic.text.primary};
  background: transparent;
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:hover {
    border-color: ${semantic.border.secondary};
  }

  &:focus {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
  }

  &:disabled {
    color: ${semantic.text.disabled};
    cursor: not-allowed;
    border-color: ${semantic.border.default};
  }

  &:disabled::placeholder {
    color: ${semantic.text.disabled};
  }

  &[aria-invalid='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.danger};
  }
`;

export const Select = styled.select`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  padding: ${layout.inputPadding};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-md']};
  color: ${semantic.text.primary};
  background-color: ${semantic.bg.canvas};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%230d0d0d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right ${space['space-500']} center;
  background-size: ${size.icon['icon-md']};
  padding-right: ${space['space-1400']};

  &:hover {
    border-color: ${semantic.border.secondary};
  }

  &:focus {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
  }

  &:disabled {
    color: ${semantic.text.disabled};
    cursor: not-allowed;
    border-color: ${semantic.border.default};
  }

  &[aria-invalid='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.danger};
  }
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
    gap: ${space['space-600']};
  }
`;

export const FormLayoutFullWidth = styled.div`
  grid-column: 1 / -1;
`;
